import {
  Company_Read_Typeahead,
  getV1CompaniesTypeahead,
  GetV1CompaniesTypeaheadData,
} from '@treadinc/horizon-api-spec';
import { FieldValues } from 'react-hook-form';

import { CompanyTypeahead } from '~hooks/useCompany/models';

import AsyncAutocompleteField from '../v2/Autocomplete/AsyncAutocompleteField';
import { CommonAsyncAutocompleteFieldProps } from '../v2/Autocomplete/types';

type Props<T extends FieldValues> = CommonAsyncAutocompleteFieldProps<
  T,
  Company_Read_Typeahead,
  CompanyTypeahead,
  GetV1CompaniesTypeaheadData
>;

export default function AutocompleteAllUserAvailableCompaniesTypeahead<
  T extends FieldValues,
>({ ...rest }: Props<T>) {
  return (
    <AsyncAutocompleteField
      {...rest}
      queryName="AutocompleteAllUserAvailableCompaniesTypeahead"
      fetchFn={{ arguments: {}, request: getV1CompaniesTypeahead }}
      parseFn={(item: Company_Read_Typeahead) => {
        const parsed = CompanyTypeahead.parse(item);

        return { _entity: parsed, label: parsed.legalName, value: parsed.id };
      }}
    />
  );
}
